import { initialMasterListState } from 'redux/initialStates';
import { status } from 'constants/general';
import masterListActionTypes from './action-types';

const masterListReducer = (state = initialMasterListState, { type, payload }) => {
  switch (type) {
    case masterListActionTypes.FETCH_SERVICES:
      return {
        ...state,
        ServicesList: {
          status: status.FETCHING,
        },
      };
    case masterListActionTypes.FETCH_SERVICES_SUCCESS:
      return {
        ...state,
        ServicesList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case masterListActionTypes.FETCH_SERVICES_FAIL:
      return {
        ...state,
        ServicesList: {
          status: status.FAIL,
        },
      };
    case masterListActionTypes.FETCH_ADD_SERVICE_SUBMISSION:
      return {
        ...state,
        addService: {
          status: status.FETCHING,
        },
      };
    case masterListActionTypes.FETCH_ADD_SERVICE_SUBMISSION_SUCCESS:
      return {
        ...state,
        addService: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case masterListActionTypes.FETCH_ADD_SERVICE_SUBMISSION_FAIL:
      return {
        ...state,
        addService: {
          status: status.FAIL,
        },
      };
    default:
      return state;
  }
};

export default masterListReducer;
